import React from 'react'
import PropTypes from 'prop-types'

import PaginationSection from 'Pods/Shared/Paginator/Paginator'
import ActionsSection from './ActionsSection'
import ConversationsRow from './ConversationsRow'
import SortableTh from './SortableTh'


function Table(props) {
  const sortableThDirection = (attribute) => {
    return props.conversations.meta.sortBy == attribute && props.conversations.meta.sortDir
  }

  return (
    <div>
      <ActionsSection
        conversations={props.conversations.data}
        selectAll={props.selectAll}
        clearFilters={props.clearFilters}
        moveCheckedToArchive={props.moveCheckedToArchive}
        hideMoveToArchiveButton={props.hideMoveToArchiveButton}
      />
      <div className="table-responsive__wrapper table--messages">
        <div className="table-responsive table-responsive--collapsing">
          <table className="table--interactive">
            <thead>
              <tr>
                <SortableTh
                  className="u-text-center"
                  attribute="recipient_username"
                  direction={sortableThDirection('recipient_username')}
                  onSortByChange={props.onSortChange}
                >
                  Contact
                </SortableTh>
                <SortableTh
                  className="u-text-center"
                  attribute="subject"
                  direction={sortableThDirection('subject')}
                  onSortByChange={props.onSortChange}
                >
                  Subject
                </SortableTh>
                <SortableTh
                  className="u-text-center"
                  attribute="conversation_type"
                  direction={sortableThDirection('conversation_type')}
                  onSortByChange={props.onSortChange}
                >
                  Type
                </SortableTh>
                <SortableTh
                  className="u-text-center"
                  attribute="created_at"
                  direction={sortableThDirection('created_at')}
                  onSortByChange={props.onSortChange}
                >
                  Date Created
                </SortableTh>
                <SortableTh
                  className="u-text-center"
                  attribute="updated_at"
                  direction={sortableThDirection('updated_at')}
                  onSortByChange={props.onSortChange}
                >
                  Last Action
                </SortableTh>
                <th />
              </tr>
            </thead>
            <tbody>
              {props.conversations.data.map((conversation, index) => (
                <ConversationsRow
                  key={conversation.id}
                  data={conversation}
                  checked={conversation.attributes.checked}
                  onChange={props.handleChange}
                  moveToArchive={props.moveToArchive}
                  unarchive={props.unarchive}
                  index={index}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <PaginationSection
        totalPages={props.conversations.meta.totalPages}
        currentPage={props.conversations.meta.currentPage}
        onPaginate={props.onPaginate}
        useHistoryApi
      />
    </div>
  )
}

Table.propTypes = {
  conversations: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      attributes: PropTypes.shape({
        checked: PropTypes.bool.isRequired,
      }),
    })).isRequired,
    meta: PropTypes.shape({
      sortBy: PropTypes.string.isRequired,
      sortDir: PropTypes.string.isRequired,
      totalPages: PropTypes.number.isRequired,
      currentPage: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  onSortChange: PropTypes.func.isRequired,
  onPaginate: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  moveToArchive: PropTypes.func.isRequired,
  unarchive: PropTypes.func.isRequired,
  moveCheckedToArchive: PropTypes.func.isRequired,
  selectAll: PropTypes.func.isRequired,
  hideMoveToArchiveButton: PropTypes.bool.isRequired,
}

export default Table
